import { useQuery } from "@apollo/client/react";
import { MyStoreDocument } from "@/generated/graphql";
import type { Store } from "@/types/models";

export function useMyStore() {
  const { data, loading, error, refetch } = useQuery(MyStoreDocument, {
    fetchPolicy: "network-only",
  });

  const store: Store | null = data?.myStore ?? null;

  return {
    store,
    loading,
    error,
    refetch,
    hasStore: !!store,
    isPublished: store?.status === "PUBLISHED",
    publicPath: store ? `/stores/${store.slug}` : null,
  };
}
